// extracted by mini-css-extract-plugin
module.exports = {"root":"root-DaVfl","arrowBackText":"arrowBackText-2zAfA","arrowBackIcon":"arrowBackIcon-Y2QAQ","icon":"icon-2xHBS","text":"text-Izsc8","both":"both-24a6f"};